<template>
	<div>
		<v-layout wrap>
			<v-flex xs12 mt-5>
				<app-table
				 title="Encuestas"
				 :name="name"
				 :filter-columns="false"
				 :rows="rows"
				 :columns="computedColumns"
				 :main-list="false"
				 class="is-not-selectable"
				 @on-search-event="$emit('on-search', $event)">
					<template slot="rows" slot-scope="{ row }">
						<td v-show="showRow(computedColumns, 1)" class="is-not-selectable border-top">{{row.poll.name}}</td>
						<td v-show="showRow(computedColumns, 2)">{{row.assignedScore}}</td>
						<td v-show="showRow(computedColumns, 3)">{{row.diagnosticStartDate || null }}</td>
						<td v-show="showRow(computedColumns, 4)">{{row.diagnosticEndDate || null }}</td>
						<td v-show="showRow(computedColumns, 5)">
							<app-tooltip-button
							text="Encuestas"
							img="https://s3.amazonaws.com/apprunn-acl/COM-PRU-01/ARQ88/image/group-39.svg"
							size="18"
							@click-icon="$emit('on-click', row.id)"
							/>
						</td>
					</template>
				</app-table>	
			</v-flex>
		</v-layout>
	</div>
</template>

<script>

function computedColumns() {
	const self = this;
	return this.columns.map((c) => {
		const col = c;
		col.visible = col.value === 'actions' ? !self.noActions : col.visible;
		if (col.value === 'points') {
			col.name = !self.noActions ? 'Puntos por Ganar' : 'Puntos Ganados';
		}
		return col;
	});
}

export default {
	name: 'poll-table',
	computed: {
		computedColumns,
	},
	props: {
		columns: {
			type: Array,
			default: () => [],
		},
		name: String,
		noActions: {
			type: Boolean,
			default: false,
		},
		rows: {
			type: Array,
			default: () => [],
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/components/polls/poll-table.vue